import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { FlexRowCenter } from "../../../Common/Styles";

export const MaxWidthContainer = styled(FlexRowCenter)`
  max-width: ${ThisGorillaUtils.convertPxToRem("694")}rem;
  width: 100%;
`;

export const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  height: fit-content;
  & button {
    cursor: move;
  }
`;
